export default "__VITE_ASSET__DQF$mEo8__"